import Api from './api';

const RHService = {
    listarConcursos: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/concurso/listar',
            params: params,
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    buscarConcurso: (params) => {
        const response = Api.get(`/concurso/buscar?${params}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })

        return response
    },
    listarEstagiarios: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/estagiario/listar',
            params: params,
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    buscarEstagiario: (params) => {
        const response = Api.get(`/estagiario/buscar?${params}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })

        return response
    },
    listarTerceirizados: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/terceirizado/listar',
            params: params,
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    buscarTerceirizados: (params) => {
        const response = Api.get(`/terceirizado/buscar?${params}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })

        return response
    }
}

export default RHService;